import React from "react";
import { Modal, Box } from "@mui/material";

import styles from "./styles";

interface ModalCompProps {
  isOpen: boolean;
  handleClose: any;
  children: React.ReactNode;
}

/**
 * ModalComp component
 * @param isOpen - Indicates if the modal is open
 * @param handleClose - Function to handle modal close event
 * @param children - React nodes to be rendered inside the modal
 */
function ModalComp({ isOpen, handleClose, children }: ModalCompProps) {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div>{children}</div>
    </Modal>
  );
}

/**
 * SimpleModalWithBackground component
 * @param isOpen - Indicates if the modal is open
 * @param handleClose - Function to handle modal close event
 * @param children - React nodes to be rendered inside the modal
 */
export const SimpleModalWithBackground = ({
  isOpen,
  handleClose,
  children,
}: ModalCompProps) => {
  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const [modalStyle] = React.useState(getModalStyle); // State hook to manage modal style

  return (
    <Modal
      open={isOpen}
      onClose={(e, reason) => {
        // Prevent closing on clicking outside and on esc
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box style={modalStyle} sx={styles.paper}>
        {/* Box component to style modal background */}
        <Box sx={styles.mainContainer}>{children}</Box>
      </Box>
    </Modal>
  );
};
export default ModalComp;
